
// page no. 708 (Audition admin)

import style from "../RoundVideoResultFour/CSS/RoundVideoResult.module.css";
import Round from "../RoundVideoResultFour/Component/Round";
import Title from "../RoundVideoResultFour/Component/Title";
import SubTitle from "../RoundVideoResultFour/Component/SubTitle";
import Banner from "../RoundVideoResultFour/Component/Banner";
import coverPhoto from "../RoundVideoResultFour/img/banner.png";
import Slider from "../RoundVideoResultFour/Component/Slider";

import sliderOne from "../RoundVideoResultFour/img/sliderOne.png";
import sliderTwo from "../RoundVideoResultFour/img/sliderThree.png";
import sliderThree from "../RoundVideoResultFour/img/sliderTwo.png";
import sliderFour from "../RoundVideoResultFour/img/sliderOne.png";
import sliderFive from "../RoundVideoResultFour/img/sliderTwo.png";
import sliderSix from "../RoundVideoResultFour/img/sliderThree.png";

import videoImage from "../RoundVideoResultFour/img/video.png";
import Details from "../RoundVideoResultFour/Component/Details";
import MargeCard from "../RoundVideoResultFour/Component/MargeCard";
import MargeCardTwo from "../RoundVideoResultFour/Component/MargeCardTwo";


const sliders = [
    {slider: sliderOne},
    {slider: sliderTwo},
    {slider: sliderThree},
    {slider: sliderFour},
    {slider: sliderFive},
    {slider: sliderSix},
];

const data = [
    {video:videoImage, star:54, user:52},
    {video:videoImage, star:34, user:84},
    {video:videoImage, star:35, user:45},
    {video:videoImage, star:78, user:45},
    {video:videoImage, star:75, user:65},
    {video:videoImage, star:25, user:75},
]

const RoundVideoResultFour = () => {
    return (
        <>
            <div className={style.section}>
                <Round round={'01'} status={'done'}/>
                <Round round={'02'} status={'done'}/>
                <Round round={'03'} status={'done'}/>
                <Round round={'04'} status={'done'}/>
                <Round round={'05'} status={'done'}/>
                <Round round={'06'} status={'done'}/>
                <Round round={'07'} status={'running'}/>
                <Round round={'08'} status={'pending'}/>
            </div>

            <div>
                <Title title={'round status'}/>
            </div>

            <div>
                <SubTitle subTitle={'submitted content'}/>
            </div>

            <div>
                <Banner title={'1st round time duration june 25 - july 30'} coverPhoto={coverPhoto}/>
            </div>

            <div>
                <Title title={'audition round-7'}/>
            </div>

            <div>
                <SubTitle subTitle={'total video - 75'}/>
            </div>

            <div>
                <Slider sliders={sliders}/>
            </div>

            <div>
                <Title title={'round7 - stars and user merge result'}/>
            </div>

            <div>
                <Details data={data}/>
            </div>

            <div>
                <Title title={'round1 - merge result for next round'}/>
            </div>

            <div>
                <MargeCard/>
            </div>

            <div>
                <Title title={'round1 - merge result for next round'}/>
            </div>

            <div>
                <MargeCardTwo/>
            </div>
        </>
    );
};

export default RoundVideoResultFour;